import type { FreeMaterialReview } from "@/types/freeMaterialsTypes"
import { CourseRatingStars } from "./FreeMaterialReviewStars"

export default function FreeMaterialReviewItem({
  review,
}: {
  review: FreeMaterialReview
}) {
  return (
    <>
      <div>
        <div className="d-flex gap-3 align-items-center">
          <p className="fs-4 fw-bold">{review?.user?.name}</p>
          <CourseRatingStars rating={review?.score || 0} />
        </div>
        <p className="fs-5 text-secondary">{review?.comment}</p>
      </div>
      <hr style={{ color: "#a0a0a0ff" }} />
    </>
  )
}
